import Filters from "./Filters";
import LosList from "./LosList";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  card: {
    background: "rgba(255 255 255)",
    padding: "30px 0 100px",
  },
});
interface IContentProps {
  isLoading?: boolean;
}
function Content({ isLoading = true }: IContentProps) {
  const classes = useStyles();
  return (
    <div className={classes.card}>
      <Filters isLoading={isLoading} />
      <LosList isLoading={isLoading} />
    </div>
  );
}

export default Content;
